import type { HeadersFunction, LoaderArgs, MetaFunction } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { fetchSupporter } from "@/lib/microcms.server";
import { CacheRevalidateMinutes, notFound } from "@/lib/responses.server";
import { createOGP } from "@/utilities/ogp";
import common from "@/data/common.json";
import { PageContainer } from "@/components/PageContainer";
import { ArticleLayout } from "@/components/ArticleLayout";
import { SupportersDescription } from "@/components/Supporters/Description";
import { SupportersArticle } from "@/components/Supporters/Article";

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return createOGP({
    path: `${common.meta.url}/supporters/${data?.post.id}`,
    pageName: `${data?.post.name} - おおかまサポーター`,
  });
};

export const headers: HeadersFunction = () => {
  return {
    "Cache-Control": CacheRevalidateMinutes(),
  };
};

export async function loader({ params }: LoaderArgs) {
  const id = params.id!;
  const post = await fetchSupporter(id).catch(() => null);

  if (!post) {
    throw notFound();
  }

  return json({ post });
}

export default function SupporterArticle() {
  const { post } = useLoaderData<typeof loader>();

  return (
    <PageContainer>
      <ArticleLayout
        paths={[
          { name: "ホーム", url: "/" },
          { name: "サポーター", url: "/supporters" },
          { name: post.name, url: `/supporters/${post.id}` },
        ]}
      >
        <h1 className="visually-hidden">サポーター: {post.name}</h1>
        <SupportersDescription />
        <span className="spacer mt-8" />
        <SupportersArticle post={post} />
      </ArticleLayout>
    </PageContainer>
  );
}
